"use strict";

import About from "../views/pages/About.js";
import PostShow from "../views/pages/PostShow.js";
import Error404 from "../views/error-pages/Error404.js";
import Categories from "../views/pages/Categories.js";
import { Leagues } from "../views/pages/League.js";
import GameByLeague from "../views/pages/GameByLeague.js";
import Match from "../views/pages/Match.js";
import LiveMatch from "../views/pages/LiveMatch.js";
import MyBets from "../views/pages/MyBets.js";
import MyBetsUsers from "../views/pages/MyBetsUsers.js";
import MyBetsUserDetails from "../views/pages/MyBetsUserDetails.js";
import AccountBalance from "../views/pages/AccountBalance.js";
import SmFinances from "../views/pages/SmFinances.js";
import CurrentBalance from "../views/pages/CurrentBalance.js";
import CreateUsers from "../views/pages/CreateUsers.js";
import Users from "../views/pages/Users.js";
import UserProfile from "../views/pages/UserProfile.js";
import LiveCasino from "../views/pages/LiveCasino.js";

import Landing from "../views/pages/Landing.js";
import InPlay from "../views/pages/InPlay.js";
import Jackpot from "../views/pages/Jackpot.js";
import ChangePassword from "../views/pages/ChangePassword.js";
import JackpotModal from "../views/components/JackpotModal.js";

import Header from "../views/components/Header.js";
import Login from "../views/components/Login.js";
import Slots from "../views/pages/Slots.js";
import { Leftpanel } from "../views/components/Leftpanel.js";
import Betslip from "../views/components/Betslip.js";

import Bottombar from "../views/components/Bottombar.js";
import Utils from "../services/Utils.js";
import { getCurrentBalance } from "../js/api/balance.js";
import { getJackPotValue } from "./api/jackpot.js";
import IframeModal from "../views/components/IframeModal.js";
import MyBetsUsersAgent from "../views/pages/MyBetsUsers_Agent.js";
import TranslationService, { _t } from '../services/TranslationService.js';
import { checkForUserGroup, getUserGroup, transformSingleCoef } from "../services/UserGroup.js";
import VirtualGames from "../views/pages/VirtualGames.js";

if (location.host === '365ecco365.net' || location.host === 'eccoplay365.com') {
    if (location.href.includes('/bettting_app/')) {
        window.location.href = location.href.replace('/bettting_app/', '/gon/');
    }
}

var routes = {
  "/": Landing,
  "/about": About,
  "/p/:id": PostShow,
  "/categories/:id": Categories,
  "/league/:id": Leagues,
  "/games/:id": GameByLeague,
  "/match/:id": Match,
  "/livematch/:id": LiveMatch,
  "/inplay": InPlay,
  "/inplay/:id": InPlay,
  "/mybets": MyBets,
  "/mybetsusers": MyBetsUsers,
  "/mybetsusers-agent": MyBetsUsersAgent,
  "/mybetsuserdetails/:id": MyBetsUserDetails,
  "/changepassword": ChangePassword,
  "/accountbalance": AccountBalance,
  "/smfinances": SmFinances,
  "/currentbalance": CurrentBalance,
  "/createnewuser": CreateUsers,
  "/users": Users,
  "/slots": Slots,
  "/virtual-games": VirtualGames,
  "/userprofile/:id": UserProfile,
  "/jackpot": Jackpot,
  "/live-casino": LiveCasino,
};

var socket = io("//ecco.socketi355.com:1440", { transports: ["websocket"] });

var on_unloadFunction;

socket.on("jackpot.released", async function (res, callback) {
  if (
    localStorage.getItem("username").toLowerCase() == res.username.toLowerCase()
  ) {
    if (res.from_client) return;

    if (res.released) {
      await JackpotModal.after_render();

      setTimeout(() => {
        JackpotModal.show(5000, res.value, res.type);
      }, 3000);
    } else if (res.checking) {
      callback(localStorage.getItem("isOnSlots") == "true");
    }
  }
});

socket.on("new-coefs", function (res) {
  if (!res || !res.coefs) return;
  
  const userGroup = getUserGroup(); // Fetch user group
  res.coefs.forEach((data) => {

    data = transformSingleCoef(data, userGroup);

    var div = document.getElementsByClassName(data.coef_id)[0];

    var span = document.getElementsByClassName(data.coef_id + "-span");
    var bs = document.getElementsByClassName(data.coef_id + "-bs");
    if (div) {
      if (
        document.getElementsByClassName(data.coef_id)[0].children.length < 2
      ) {
        document.getElementsByClassName(data.coef_id)[0].innerHTML = (
          Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100
        ).toFixed(2);
      }

      document
        .getElementsByClassName(data.coef_id)[0]
        .setAttribute(
          "match-odd",
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2)
        );
    }
    if (bs) {
      let coefHasChanged = localStorage.getItem("coefHasChanged");
      for (let index = 0; index < bs.length; index++) {
        let element = bs[index];
        const oldPrice = element.getAttribute("match-odd")
          ? element.getAttribute("match-odd")
          : element.outerText;
        if (
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2) ==
          (Math.floor(parseFloat(oldPrice) * 100) / 100).toFixed(2)
        )
          continue;
        let color =
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2) >
          (Math.floor(parseFloat(oldPrice) * 100) / 100).toFixed(2)
            ? "green"
            : "red";

        element.setAttribute(
          "match-odd",
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2)
        );
        element.innerHTML = `<span style=" text-decoration: line-through;">${(
          Math.floor((parseFloat(oldPrice) + Number.EPSILON) * 100) / 100
        ).toFixed(2)}</span><span style="color:${color}">${(
          Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100
        ).toFixed(2)}</span>`;

        coefHasChanged = true;
      }

      calculatePrice();

      if (coefHasChanged == true) {
        localStorage.setItem("coefHasChanged", coefHasChanged);
        $("#btnDescription").text(_t("Prano ndryshimet"));
        $("#valueIcon").text("");
        $("#placeBetValue").text("");
      }
    }

    if (span) {
      for (let index = 0; index < span.length; index++) {
        let element = span[index];
        element.setAttribute(
          "match-odd",
          (Math.floor(parseFloat(data.odd) * 100) / 100).toFixed(2)
        );
        element.innerHTML = `<span>${(
          Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100
        ).toFixed(2)}</span>`;
      }

      calculatePrice();
    }

    updateCoefLocalStorage(data.coef_id, data.odd);
  });

  updateMatch();
});

socket.on("delete-live-game", function (data) {
  var liveGame = document.getElementById(data.id);

  if (liveGame) {
    liveGame.parentNode.removeChild(liveGame);
    //liveGame.innerHTML = "";
  }
});

socket.on("delete-live-coef", function (data) {
  var liveCoef = document.getElementsByClassName(`${data.id}-coef`);

  if (liveCoef && liveCoef[0]) {
    liveCoef[0].innerText = "1.00";
  }
});

function eraseCache(version) {
  const href = window.location.href.split("?")[0];
  window.location = href + "?v=" + version;
}

var setDefaults = async function () {
  try {
    if (location.hostname == 'sportgamble.net') {
      // Leave only English language for sportgamble.net
      TranslationService.defaultLang = 'en';
      TranslationService.languages = [{ key: 'en', name: 'English' }];
    }
    
    if (location.hostname == 'euro444.com') {
      // Set default language English for euro444.com
      TranslationService.defaultLang = 'en';
    }

    await TranslationService.loadTranslations().then(() => {
      TranslationService.translateStatics();
    });
  } catch { }

  localStorage.setItem("isOnSlots", false);

  const lastVersionDate = localStorage.getItem("version-date-1");
  const ONE_HOUR = 60 * 60 * 1000;

  if (!lastVersionDate || new Date() - new Date(lastVersionDate) > ONE_HOUR) {
    localStorage.setItem("version-date-1", new Date());
    eraseCache(new Date().getTime());
  }

  var header = null || document.getElementById("header_container");
  var footer = null || document.getElementById("footer_container");
  var betslip = null || document.getElementById("betslip");

  header.innerHTML = `${await Header.render()}  ${await JackpotModal.render()}`;
  await Header.after_render();

  betslip.innerHTML = await Betslip.render();
  await Betslip.after_render();

  footer.innerHTML = `${await Bottombar.render()}  ${await IframeModal.render()}`;
  await Bottombar.after_render();
  await IframeModal.after_render();

  var itemArray = JSON.parse(localStorage.getItem("addObject")) || [];
  itemArray.forEach((item) => {
    socket.emit("connectToRoom", { room: item.gameId });
  });
};

var router = async function () {
  var leftpanel = null || document.getElementById("leftpanel_container");
  var login = null || document.getElementById("login_container");
  var content = null || document.getElementById("content_container");
  let request = Utils.parseRequestURL();

  let parsedURL =
    (request.resource ? "/" + request.resource : "/") +
    (request.id ? "/:id" : "") +
    (request.verb ? "/" + request.verb : "");

  if (parsedURL == "/slots") {
    $("body").removeClass("bg-black");
  } else {
    $("body").removeClass("bg-black");
  }
  await saveJackpotValue();

  login.innerHTML = await Login.render();
  await Login.after_render();

  leftpanel.innerHTML = await Leftpanel.render();
  await Leftpanel.after_render();

  let page = routes[parsedURL] ? routes[parsedURL] : Error404;

  // console.log(parsedURL);

  $("#contentLoader").append(
    '<div class="loaderWrapper">\n' +
      '            <div class="loader"></div>\n' +
      "        </div>"
  );
  window.scrollTo(0, 0);

  if (on_unloadFunction) on_unloadFunction(socket);

  content.innerHTML = await page.render();
  await page.after_render(socket);
  on_unloadFunction = page.on_unload;
  await updateMatch();
  $("body .loaderWrapper").remove();

  setCurrentBalance();
};

async function loadLiveCasino() {
  window.location.href = "#/live-casino";
}

async function saveJackpotValue() {
  const value = await getJackPotValue();
  if (value) {
    localStorage.setItem(
      "jackpot_value",
      (
        Math.floor((parseFloat(value.actual_jackpot) + Number.EPSILON) * 100) /
        100
      ).toFixed(2)
    );

    localStorage.setItem(
      "jackpot_live",
      (
        Math.floor(
          (parseFloat(value.actual_jackpot_live) + Number.EPSILON) * 100
        ) / 100
      ).toFixed(2)
    );

    localStorage.setItem(
      "jackpot_prematch",
      (
        Math.floor(
          (parseFloat(value.actual_jackpot_prematch) + Number.EPSILON) * 100
        ) / 100
      ).toFixed(2)
    );
  }
}
if (axios && axios.interceptors && axios.interceptors.response) {
  axios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (!response || (response && !response.data)) {
        return response;
      }
  
      if (response.data.error == "Expired token") {
        localStorage.removeItem("role");
        localStorage.removeItem("name");
        localStorage.removeItem("access_token");
        localStorage.removeItem("surname");
        location.reload(true);
      } else return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    }
  );
}
var i = 0;

function getCombinations(input, size) {
  var results = [],
    result,
    mask,
    total = Math.pow(2, input.length);
  for (mask = 0; mask < total; mask++) {
    result = [];
    i = input.length - 1;
    do {
      if ((mask & (1 << i)) !== 0) {
        result.push(input[i]);
      }
    } while (i--);

    //ne qofte se duhen edhe bastet teke edhe vareja duhet ky rresht
    // if (result.length <= size && result.length > 0) {
    //perndryshe duhet ky
    if (result.length == size && result.length > 1) {
      results.push(result);
    }
  }
  //console.log(results);
  return results;
}

function treatCombinations(s) {
  var min = false;
  var max = [];
  var maxOdd = false;
  var arr = s;
  var l = arr.length;
  let value = 0;
  let element = document.getElementById("placeBetAreaValue");
  if (element && element.value) value = parseFloat(element.value) / l;

  var i = 0;
  for (; i < l; ) {
    (function (q) {
      var odd = value;
      for (var j in q) {
        odd = odd * q[j];
      }
      if (!min) {
        min = odd;
      } else if (odd < min) {
        min = odd;
      }
      if (!maxOdd) {
        maxOdd = odd;
      } else if (odd > maxOdd) {
        maxOdd = odd;
      }
      max.push(odd);
    })(arr[i]);
    i = i + 1;
  }

  let newMax = 0;
  for (let index = 0; index < max.length; index++) {
    var element1 = max[index];
    newMax += element1;
  }

  return {
    min: min,
    max: max,
    maxOdd: maxOdd,
    combNo: l,
    newMax,
  };
}

export async function setCurrentBalance() {
  var currentBalanceResult = await getCurrentBalance();
  const blockedSports = JSON.stringify(currentBalanceResult['blocked_sports'] ? currentBalanceResult['blocked_sports'].split(",") : []);
  const reloadNeeded = localStorage.getItem("blockedSports") !== blockedSports;
  localStorage.setItem("blockedSports", blockedSports);

  var coins = [];
  var allText = "";

  if (currentBalanceResult && currentBalanceResult.total_coins) {
    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
        allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
        allText += `<b>${currentBalanceResult.currency} ${parseFloat(
          currentBalanceResult.total_coins
        ).toFixed(2)} </b>`;
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });

        const value = currentBalanceResult.total_coins.split(";")[1];
        allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    }

    $(".currentBalanceNew").html(allText);

    localStorage.setItem("coins", JSON.stringify(coins));

    if (reloadNeeded) {
      window.location.reload();
    }
  }
}

function calculatePrice(value) {
  if (!value) {
    value = document.getElementById("placeBetAreaValue").value;
  }
  let totalValue = 1;

  itemArray.forEach((item) => {
    totalValue = totalValue * item.coefVal;
  });
  totalValue = totalValue * value;

  var size = $("#systemBtn").val();

  if (size && size !== "-1") {
    var odds = [];

    itemArray.forEach((element) => {
      odds.push(element.coefVal);
    });

    var s = getCombinations(odds, size);
    var r = treatCombinations(s);

    $("#winningPrice")[0].innerHTML = `${Math.round(r.min * 100) / 100} / ${
      Math.round(r.newMax * 100) / 100
    }`;
  } else {
    document.getElementById("winningPrice").textContent =
      parseFloat(totalValue).toFixed(2);
  }
}

window.addEventListener(
  "addToRoom",
  function (e) {
    socket.emit("connectToRoom", { room: e.detail });
  },
  false
);

window.addEventListener(
  "loadLiveCasino",
  function (e) {
    loadLiveCasino();
  },
  false
);

window.addEventListener(
  "leaveRoom",
  function (e) {
    let itemArray = JSON.parse(localStorage.getItem("addObject")) || [];
    var check = itemArray.filter((a) => a.gameId == e.detail);
    if (!check || check <= 0) {
      socket.emit("leaveRoom", { room: e.detail });
    }
  },
  false
);

setDefaults();
window.addEventListener("hashchange", router);
window.addEventListener("load", router);

document.addEventListener("visibilitychange", function () {
  setCurrentBalance();
  console.log("visibilitychange");
});


checkForUserGroup();
